import { createApiClient } from '@mds/shared/lib/api';

/** The admin app's API client, pointed at VITE_API_URL or the dev proxy. */
export const api = createApiClient({
  baseUrl: import.meta.env.VITE_API_URL ?? '/api',
});
